export default interface Vehicle {
    modelo: string;
    placa: string;
    ano: number;
    cor: string;
    tipoVeiculo: number;
}

export enum TypeVehicle {

    Sedan = 0,
    MiniVan = 1,
    Van = 2,
    Van14 = 3,
    BlackSUV = 4

}

export const listTypeVehicles: {
    value: TypeVehicle,
    label: string,
    icon?: string,
    countpassager?: number,
    bag?: number
}[] = [
        { value: TypeVehicle.Sedan, label: 'Sedan', icon: 'assets/images/sedan.png', countpassager: 4, bag: 4 },
        { value: TypeVehicle.MiniVan, label: 'Mini Van', icon: 'assets/images/mini-van.png', countpassager: 6, bag: 6 },
        { value: TypeVehicle.BlackSUV, label: 'Black (SUV)', countpassager: 7, icon: 'assets/images/suv.png', bag: 7 },
        { value: TypeVehicle.Van, label: 'Van Pax 10', countpassager: 10, icon: 'assets/images/van.png', bag: 10 },
        { value: TypeVehicle.Van14, label: 'Van Pax 14', countpassager: 14, icon: 'assets/images/van14.png', bag: 0 }
    ];